import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import * as moment from 'moment';
import { DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT, loaiTuyenSinhValue, objectLoaiTuyenSinh, trangThaiDotTuyenSinhValue, objectTrangThaiDotTuyenSinh } from '../../../../../utils/define';

const ChiTietLopDaoTaoLienTucModal = ({ isOpen, onClose, data, getDonViName }) => {
    if (!data) return null;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
            style={{ zIndex: '9999' }}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary font-weight-bold">Chi tiết Tuyển sinh Đào tạo liên tục</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                <h5 className="text-info mb-3 border-bottom pb-2">Thông tin chung</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <p><strong>Tên khóa học:</strong> <span className="text-danger">{data.tenKhoaHoc || data.TenKhoaHoc}</span></p>
                        <p><strong>Loại tuyển sinh:</strong> <span className="badge badge-success">{getLabelFromEnum(data.loaiTuyenSinh ?? data.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</span></p>
                        <p><strong>Số thông báo tuyển sinh:</strong> {data.soQuyetDinh || data.SoQuyetDinh}</p>
                        <p><strong>Trạng thái:</strong> <span className="badge badge-primary">{getLabelFromEnum(data.trangThaiDotTuyenSinh ?? data.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue)}</span></p>
                    </Col>
                    <Col md={6}>
                        <p><strong>Khoa đề xuất:</strong> {getDonViName(data.khoaDeXuatId || data.KhoaDeXuatId)}</p>
                        <p><strong>Thời gian khóa học:</strong> {data.thoiGianKhoaHoc || data.ThoiGianKhoaHoc} tháng</p>
                        <p><strong>Số lượng học viên:</strong> {data.soLuongHocVien || data.SoLuongHocVien}</p>
                        <p><strong>Học phí:</strong> {(data.hocPhi != null || data.HocPhi != null) ? new Intl.NumberFormat('vi-VN').format(data.hocPhi ?? data.HocPhi) : '0'} VNĐ</p>
                    </Col>
                </Row>

                <h5 className="text-info mb-3 border-bottom pb-2">Thời gian đào tạo & Nhận hồ sơ</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <p><strong>Ngày khai giảng:</strong> {(data.ngayKhaiGiang || data.NgayKhaiGiang) ? moment(data.ngayKhaiGiang || data.NgayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày bế giảng:</strong> {(data.ngayBeGiang || data.NgayBeGiang) ? moment(data.ngayBeGiang || data.NgayBeGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                    </Col>
                    <Col md={6}>
                        <p><strong>Ngày bắt đầu nhận hồ sơ:</strong> {(data.ngayBatDauNhanHoSo || data.NgayBatDauNhanHoSo) ? moment(data.ngayBatDauNhanHoSo || data.NgayBatDauNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày kết thúc nhận hồ sơ:</strong> {(data.ngayKetThucNhanHoSo || data.NgayKetThucNhanHoSo) ? moment(data.ngayKetThucNhanHoSo || data.NgayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                    </Col>
                </Row>

                <h5 className="text-info mb-3 border-bottom pb-2">Nội dung chi tiết</h5>
                <div className="mb-3">
                    <strong>Mục đích khóa học:</strong>
                    <div 
                        className="p-3 bg-light rounded mt-2" 
                        dangerouslySetInnerHTML={{ __html: data.mucDichKhoaHoc || data.MucDichKhoaHoc || '<i>Chưa cập nhật</i>' }} 
                    />
                </div>
                <div className="mb-3">
                    <strong>Nội dung khóa học:</strong>
                    <div 
                        className="p-3 bg-light rounded mt-2" 
                        dangerouslySetInnerHTML={{ __html: data.noiDungKhoaHoc || data.NoiDungKhoaHoc || '<i>Chưa cập nhật</i>' }} 
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChiTietLopDaoTaoLienTucModal;
